import { CALL_PREFERRED_TIME } from "../const"

export const getAcceptanceStatus = (chatHistory: {
  type: number | null;
  updatedInsuranceFeePlan: number | null;
  acceptanceStatus: number | null;
  callPreferredTime: number | null;
  hasPassed14DaysSincePublishedUrl: boolean;
  urlInvalidFlg: number | null;
}): string => {
  //　フリーメッセージ
  if (chatHistory?.type === 2) {
    return '-';
  }

  //　URL送信
  if (chatHistory?.acceptanceStatus === 2) {
    //  acceptanceStatus 2：「承諾済み」
    if (chatHistory?.type === 1) {
      // 金銭異動承諾
      return chatHistory?.updatedInsuranceFeePlan === 1
        ? '承諾(プラン①)'
        : chatHistory?.updatedInsuranceFeePlan === 2
          ? '承諾(プラン② ~ 新価特約)'
          : '不正なデータ(承諾/プラン)';
    } else {
      return "回答済み"
    }
  } else if (chatHistory?.acceptanceStatus === 3) {
    //  acceptanceStatus 3：「連絡希望」
    return toCallPreferredLabel(chatHistory?.callPreferredTime)
  } else if (chatHistory?.acceptanceStatus === 4) {
    //  acceptanceStatus 4：「更問」
    return '確認事項あり'
  } else if (chatHistory?.urlInvalidFlg || chatHistory?.hasPassed14DaysSincePublishedUrl) {
    return 'URL無効';
  } else if (chatHistory?.acceptanceStatus === 1) {
    //  acceptanceStatus 1：「未回答」
    return '回答待ち';
  } else {
    return '不正なデータ';
  }
};

export const toCallPreferredLabel = (callPreferredTime: number | null) => {
  const label = CALL_PREFERRED_TIME[String(callPreferredTime)]
  return label ? label : '不正なデータ(連絡希望)';
}
